<template>
  <div class="input-array-items">
    <div class="input-array-item flex-row" v-for="(item, key) in items" :key="key">
      <div class="input-array-item-control flex1">
        <slot :item="item"></slot>
      </div>
      <div class="input-array-item-btns flex-row align-items-start ml8">
        <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
        <el-button icon="el-icon-plus" tabindex="-1" v-if="showAdd" @click="addItem(key)"></el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArrayItem",
  props: {
    items: Array,
    showAdd: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    removeItem(key) {
      if (this.items.length > 1) {
        this.items.splice(key, 1)
      } else {
        this.items.splice(key, 1, {})
      }
    },
    addItem(key) {
      this.items.splice(key + 1, 0, {})
    }
  }
}
</script>

<style scoped lang="scss">
.input-array-items {
  .input-array-item + .input-array-item {
    margin-top: 10px;
  }
}
</style>